import { useMutation, useQueryClient } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

export const acceptAccreditationVersion = async (
  organizationId: string,
  accreditationBodyId: string,
  versionId: string,
  onError?: (errors: ServerErrorResponse) => void
): Promise<void> => {
  try {
    await fetcher({
      method: 'post',
      url: `${baseApiUrl()}/awb/accreditation-body/v1/organizations/${organizationId}/accreditation-bodies/${accreditationBodyId}/versions/${versionId}/accept`,
    });
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export default function useAcceptAccreditationVersion(onError?: (errors: ServerErrorResponse) => void) {
  const queryClient = useQueryClient();

  return useMutation<
    void,
    ServerErrorResponse,
    { organizationId: string; accreditationBodyId: string; versionId: string }
  >(
    async ({ organizationId, accreditationBodyId, versionId }) =>
      acceptAccreditationVersion(organizationId, accreditationBodyId, versionId, onError),
    {
      onSuccess: async (_, { organizationId }) => {
        const key = organizationId || '';
        await queryClient.refetchQueries(['accreditationVersionsAvailable', key]);
        queryClient.invalidateQueries(['accrediting_bodies', key]);
      },
      onError: (error) => {
        if (onError) {
          onError(error);
        }
      },
    }
  );
}
